import React from 'react';
import { motion } from 'framer-motion';
import discoveryIcon    from '../../assets/images/discovery-process-icon.webp';
import designIcon       from '../../assets/images/design-procss-icon.webp';
import developmentIcon  from '../../assets/images/development-process-icon.webp';
import deploymentIcon   from '../../assets/images/deployment-process-icon.webp';
import '../../assets/styles/ProcessSection.css';

const steps = [
  { title: 'Discovery',    icon: discoveryIcon,
    desc: 'Taking the time to understand your business, your customers, and your goals to create a solid foundation.' },
  { title: 'Strategy',     icon: designIcon,
    desc: "Together, we'll craft a tailored plan for your website's design and functionality, ensuring it resonates with your audience." },
  { title: 'Development',  icon: developmentIcon,
    desc: "Bringing your vision to life, building a website that's both visually appealing and user-friendly." },
  { title: 'Launch',       icon: deploymentIcon,
    desc: 'Your website goes live. I ensure a smooth transition and provide training so you\'re ready to take the reins.' },
];

const ProcessSection = () => (
  <motion.section
    id="process"
    className="process-section section"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: 'easeOut' }}
    viewport={{ once: true, amount: 0.1 }}
  >
    <div className="section-inner">
      <p className="eyebrow centered">How we work</p>
      <h2 className="centered">My process</h2>
      <p className="intro centered">
        Here's how I work with you to create a website that not only looks great, but delivers results.
      </p>

      <div className="process-steps">
        {steps.map((step, i) => (
          <motion.div
            key={step.title}
            className="process-step"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 + i * 0.12 }}
            viewport={{ once: true, amount: 0.1 }}
          >
            <div className="step-num">0{i + 1}</div>
            <img src={step.icon} alt="" />
            <h4>{step.title}</h4>
            <p>{step.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </motion.section>
);

export default ProcessSection;
